import * as types from './mutation-types'


export default {
  [types.UPDATE_SESSION] (state, session) {
    state.currentSession = session
    state.sellerName = session ? session.seller.fullname.trim().toUpperCase() : ""
    state.sellerId = session ? session.operator_id : null
    state.company = session ? session.shop : {}
    state.currency =   session && session.shop && session.shop.country && session.shop.country.currencie ? session.shop.country.currencie : {iso: 'XOF', symbole: 'FCFA'}
  },

  [types.UPDATE_SHOP_BOX] (state, shopBox) {
    state.currentShopBox = shopBox
  },

  [types.ADD_BOXES] (state, boxes) {
    state.boxes = boxes
  },

  SET_SELLER_NAME: function (state, sellerName) {
    state.sellerName = sellerName.trim().toUpperCase()
  },

  SET_SELLER_ID: function (state, sellerId) {
    state.sellerId = sellerId
  },

  SET_COMPANY: function (state, company) {
    state.company = company
  },

  SET_CURRENCY: function(state, currency){
    state.currency = currency ?? {iso: 'XOF', symbole: 'FCFA'}
  }

}


